import { useEffect, useRef } from 'react'

import loadingHav from 'assets/animations/loading-havaianas.json'
import lottie, { type AnimationItem } from 'lottie-web'

import * as S from './styles'

export interface LoadingHavaianasProps {
  loadingText?: string
  title?: string
  description?: string
}

export const LoadingHavaianas: React.FC<LoadingHavaianasProps> = ({
  loadingText = 'Carregando...',
  title,
  description,
}) => {
  const animationContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let animation: AnimationItem | undefined

    if (animationContainerRef.current) {
      animation = lottie.loadAnimation({
        animationData: loadingHav,
        autoplay: true,
        container: animationContainerRef.current,
        loop: true,
        renderer: 'svg',
      })
    }
    return () => {
      animation?.destroy()
    }
  }, [])

  return (
    <S.Wrapper>
      <S.AnimationContainer ref={animationContainerRef} />
      <S.LoadingText>{loadingText}</S.LoadingText>
      {!!title && <S.LoadingTitle>{title}</S.LoadingTitle>}
      {!!description && <S.LoadingDescription>{description}</S.LoadingDescription>}
    </S.Wrapper>
  )
}
